import { Autocomplete, TextField } from '@mui/material';
import { validateNotNullOrUndefined } from '@weft/utils';
import { Spinner } from 'apps/app/src/components/design/Spinner';
import { useMeterInstanceKeys } from 'apps/app/src/hooks/requests/use-meter-instance-keys';

export type InstanceKeyValueSelectorProps = {
  productId: string | undefined;
  customerId: string | undefined;
  instanceKey: string;
  onValueSelected: (instanceKey: string | undefined) => void;
};

export const InstanceKeyValueSelector: React.FC<InstanceKeyValueSelectorProps> = ({ productId, customerId, instanceKey, onValueSelected }) => {
  validateNotNullOrUndefined(productId);
  validateNotNullOrUndefined(customerId);
  
  const { data: instanceKeysResult, isLoading } = useMeterInstanceKeys(productId, customerId);

  return (
    <div className='flex items-center gap-4'>    
      <Autocomplete
        disablePortal
        disabled={isLoading}
        onChange={(_, value) => onValueSelected(value ?? undefined)}
        options={instanceKeysResult?.instanceKeys ?? []}
        sx={{ width: 300 }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={`Select ${instanceKey}`}
          />
        )}
      />
      {isLoading && (
        <div>
          <Spinner />
        </div>
      )}
    </div>

  );
};